import React from 'react'
import { Route, Switch } from "react-router-dom"

import Species from './Screens/Species/Species'
import Home from './Screens/Home/Home'
import Header from './Screens/Header/Header'
// import Team from './Screens/Team/Team'
import Sandaga from './Screens/Sandaga/Sandaga'
import Knownfacts from './Screens/Knownfacts/Knownfacts'
import Kits from './Screens/Kits/Kits'
import Footer from "./Screens/Footer/Footer"
import Login from "./Screens/Register/Register"
import Explore from "./Screens/Explore/Explore"

import Dashboard from "./Screens/Dashboard/Admin"
// import AdminBlog from './Screens/Dashboard/Admin Blog/index'
// import AddPost from './Screens/Dashboard/Admin Blog/Add Post/AddPost'

import "./App.scss"

const App = () => {
  return (
    <>
      <div className="app_container">
        <Header />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/species" component={Species} />
          <Route path="/footer" component={Footer} />
          {/* <Route path="/team" component={Team} /> */}
          <Route path="/sandaga" component={Sandaga} />
          <Route path="/known-facts" component={Knownfacts} />
          <Route path="/kits" component={Kits} />
          <Route exact path="/admin" component={Login} />
          <Route path="/explore" component={Explore} />
          
          <Route path="/dashboard" component={Dashboard} />
          {/* <Route path="/admin/blog" component={AdminBlog} />
          <Route path="/admin/blog/create-post" component={AddPost} /> */}
        </Switch>
        <Footer />
      </div>
    </>
  )
}

export default App
